import { render, staticRenderFns } from "./VideoPreviewCanvas.vue?vue&type=template&id=58e6b34c&scoped=true&"
import script from "./VideoPreviewCanvas.vue?vue&type=script&lang=js&"
export * from "./VideoPreviewCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6b34c",
  null
  
)

export default component.exports